import { useNavigate } from "react-router-dom";
import ZionNationalPark from "../../assets/png/defense.png";
const DefendBanner = ({ NotShowBtn }) => {
  const navigate = useNavigate();

  return (
    <div className="">
      <div className="relative">
        <img src={ZionNationalPark} alt="" className="w-[-webkit-fill-available]" />
        <div
          className="
        bottom-0 
        absolute 
        text-[#F2F2F2CC] 
        font-extrabold
        font-[Rockwell]

        2xl:text-[165px]
        lg:text-[104px]
        md:text-[85px] 
        sm:text-[65px] 
        text-[30px] 

        2xl:leading-[121px]
        lg:leading-[74px]
        md:leading-[60px] 
        sm:leading-[47px] 
        leading-[28px]

        flex justify-center items-center w-[-webkit-fill-available] "
        >
          BUILT TO DEFEND
        </div>
      </div>
    </div>
  );
};
export default DefendBanner;
